module.exports = __webpack_public_path__ + "img/intelligence-content.9eb7fad9.png";